import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSettings } from "utils/settingsContext";
import { Icon, Text, HStack, VStack, Box } from "@chakra-ui/react";
import CountrySelector from "./CountrySelector";
import { IoIosAddCircleOutline } from "react-icons/io";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

const AddBankAccountButton = ({ onSelect, countrySelectSize }) => {
  const { appSettings } = useSettings();
  const [showCountrySelector, setShowCountrySelector] = useState(false);

  const supportedBankAccountCountries = appSettings.supported_bank_account_countries || {};

  const handleCountrySelect = (countryOption) => {
    const countryISO = countryOption.value;
    const currency = countryOption.currency;
    const countryFormType = supportedBankAccountCountries[countryISO].add_bank_type || "masspay-form"; // default to masspay-form, only other current option is "plaid"

    onSelect &&
      onSelect({ name: countryOption.label, ISO: countryISO, type: countryFormType, currency });
  };

  const handleClick = () => {
    setShowCountrySelector(!showCountrySelector);
  };

  return (
    <VStack align="flex-start">
      <HStack
        spacing="1"
        color="integrator.400"
        fontWeight="600"
        cursor="pointer"
        onClick={handleClick}
      >
        <Icon as={IoIosAddCircleOutline} w="5" h="5" />
        <Text>
          <FormattedMessage defaultMessage="Add bank account" description="button label" />
        </Text>
        {showCountrySelector ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </HStack>
      <Box display={showCountrySelector ? "inline" : "none"}>
        {/* using a box instead of Collapse component as there are css issues using a Selector component within Collapse */}
        <VStack align="flex-start" gap="0">
          <Text fontSize="sm" color="secondaryText" pb="2">
            <FormattedMessage
              defaultMessage="Please select the country your bank account is in:"
              description="User message"
            />
          </Text>
          <CountrySelector size={countrySelectSize} onChange={handleCountrySelect} />
        </VStack>
      </Box>
    </VStack>
  );
};

export default AddBankAccountButton;
